@if (defaultCountry !== 'NL') {
  <div class="client-search__block">
    <mat-form-field appearance="fill" class="client-search__form-field">
      <mat-label class="client-search__label"
                 [innerHTML]="translationService.getTranslation('label_backendid')"></mat-label>
      <input class="client-search__input" maxLength="50" (input)="loadClient()" matInput type="text"
             [(ngModel)]="clientno" #clientNo>
      @if (clientNo === document?.activeElement && clientNo.value.length >= 1) {
        <mat-hint class="client-search__hint" align="end">{{ clientNo.value.length }}/ {{ clientNo.maxLength }}
        </mat-hint>
      }
      @if (!validationIsActive) {
        <button class="client-search__button" matSuffix mat-icon-button (click)="validateClientAndEmit()">
          <mat-icon class="client-search__icon">search</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>
} @else {
  <div class="client-search__row row">
    <div class="client-search__col col-6">
      <mat-form-field appearance="fill" class="client-search__form-field">
        <mat-label class="client-search__label"
                   [innerHTML]="translationService.getTranslation('address_postcode')"></mat-label>
        <input class="client-search__input" matInput type="text" [(ngModel)]="zipCode" (keyup)="validateZipCodeNL()"
               pattern="\d{4}[A-Z]{2}">
        <mat-hint class="client-search__hint">{{ translationService.getTranslation('clientSearch_helper_postcode') }}
        </mat-hint>
        <mat-error
          class="client-search__error">{{ translationService.getTranslation('clientSearch_helper_postcode') }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="client-search__col col-6">
      <mat-form-field appearance="fill" class="client-search__form-field">
        <mat-label class="client-search__label"
                   [innerHTML]="translationService.getTranslation('address_houseno')"></mat-label>
        <input class="client-search__input" matInput type="text" [(ngModel)]="houseNumber" (keyup)="validateHouseNoNL()"
               pattern="\d{1,5}">
        <mat-hint class="client-search__hint">{{ translationService.getTranslation('clientSearch_helper_houseNo') }}
        </mat-hint>
        <mat-error class="client-search__error">{{ translationService.getTranslation('clientSearch_helper_houseNo') }}
        </mat-error>
        @if (zipCodeNlValid && houseNoNlValid) {
          <button class="client-search__button" matSuffix mat-icon-button (click)="loadClientNl()">
            <mat-icon class="client-search__icon">search</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </div>
}

@if (((validationIsActive && defaultCountry !== 'NL') || (defaultCountry === 'NL' && validationIsActive && !onlyOneResult)) && clientSelected) {
  <div class="client-search__row row">
    <form class="client-search__form searchForm" [formGroup]="validationForm" (ngSubmit)="validateClientAndEmit()">
      @for (search_factor of validationFactors; track search_factor) {
        <mat-form-field appearance="fill"
                        class="client-search__form-field"
                        [ngClass]="validationFactors.length === 1 ? 'col-12' : 'col-12 col-md-6'">
          <mat-label class="client-search__label"
                     [innerHTML]="translationService.getTranslation(search_factor != 'zipcode' ? 'address_' + search_factor : 'address_postcode')"></mat-label>
          <input class="client-search__input" matInput type="text" formControlName="{{search_factor}}">
        </mat-form-field>
      }
    </form>
    @if (!isLoading && !validationSuccessful) {
      <div class="client-search__row row">
        <div class="client-search__col col-3">
          <button class="client-search__button" (click)="validateClientAndEmit()" mat-raised-button
            color="primary">{{ translationService.getTranslation('find_subscriptions') }}
          </button>
        </div>
      </div>
    }
  </div>
}

@if (clientnoNotFound || inputInvalid) {
  <div class="client-search__alert alert alert-warning row mb-2 mt-3">
    <div class="client-search__col col-12">
      <div class="client-search__alert-text"
           [innerHTML]="translationService.getTranslation('complaint_cannot_find_clientno')">
      </div>
    </div>
  </div>
}

@if (isLoading) {
  <div class="client-search__loading" style="text-align: center;">
    <app-loading-spinner [type]="'small'"></app-loading-spinner>
  </div>
}
